import SSpyHandler from './SSpyHandler'

export default SSpyHandler
